import React from 'react';

const HelpIcon = ({ size = 20, color = 'currentColor', ...props }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 9.50037C9 9.50037 9.045 8.46912 10.0481 7.64224C10.6437 7.1513 11.3591 7.00912 12 7.00037C12.5853 6.99318 13.1084 7.09224 13.4213 7.24474C13.9559 7.50662 15 8.14412 15 9.50037C15 10.9276 14.0881 11.5744 13.0516 12.2872C12.015 13.0001 11.75 13.6991 11.75 14.5004"
      stroke="#E96618"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M11.75 15.8906C12.2937 15.8906 12.7344 16.3313 12.7344 16.875C12.7344 17.4187 12.2937 17.8594 11.75 17.8594C11.2063 17.8594 10.7656 17.4187 10.7656 16.875C10.7656 16.3313 11.2063 15.8906 11.75 15.8906Z"
      fill="#E96618"
      stroke="#E96618"
      strokeWidth="0.03125"
    />
  </svg>
);

export default HelpIcon;
